import Link from "next/link";
import Breadcrum from "../common/breadcrum";

const TravelType = ({ placesTypeList }) => {
  return (
    <div className="main-wrapper pt-[24px]  min-h-[72vh]">
      <Breadcrum className="main-wrapper !p-[4px_0] !w-full" />
      <div className="row">
        {Object.keys(placesTypeList).map((type, i) => {
          return (
            <div key={i} className="col-4 mb-[24px] mb-[32px]">
              <h3 className="capitalize">{type}</h3>
              {placesTypeList[type]?.map((place, i) => {
                return (
                  <h3 key={i} className="leading-none">
                    <Link
                      className="text-[16px]"
                      href={`/trip/${place.typeSlug}`}
                    >
                      {place?.title} ({type})
                    </Link>
                  </h3>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TravelType;
